import {createSlice} from "@reduxjs/toolkit";

const initialState = {
	items: [],
	loading: false,
	error: null,
	filter: {
		keyword: '',
		status: '',
		date_from: '',
		date_to: '',
	},
	pagination: {
		page: 1,
		limit: 20,
		total: 0,
	},
};

const order = createSlice({
	name: 'order',
	initialState,
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		setFilter(state, action) {
			state.filter = {...state.filter, ...action.payload};
			return state;
		},
		setPagination(state, action) {
			state.pagination = {...state.pagination, ...action.payload};
			return state;
		},
	},
});

//Actions
export const orderActions = order.actions;
//Reducer
export const orderReducer = order.reducer;
//Selectors
export const orderItemsSelector = (state) => state.order.items;
export const orderLoadingSelector = (state) => state.order.loading;
export const orderErrorSelector = (state) => state.order.error;
export const orderFilterSelector = (state) => state.order.filter;
export const orderPaginationSelector = (state) => state.order.pagination;
